import * as tus from 'tus-js-client';
import { finalizeUpload } from "./attachment.js"

export const createAttachment = async (file, permissions = {}, uploadCallback = () => {}) => {
  return new Promise((resolve, reject) => {
    const upload = new tus.Upload(file, {
      endpoint: '/files',
      retryDelays: [0, 3000, 5000, 10000],
      onError: (error) => {
        console.log('Upload error:', error);
        reject(error);
      },
      onProgress: (uploaded, total) => {
        console.log(`Progress: ${uploaded}/${total}`);
      },
      onSuccess: async () => {
        try {
          const uploadURL = upload.url;
          const res = await finalizeUpload(file, { uploadURL }, permissions);
          if (res.error) {
            alert(res.error);
            reject(res.error);
          } else {
            uploadCallback(res);
            resolve(res);
          }
        } catch (err) {
          reject(err);
        }
      }
    });

    upload.start();
  });
}
